export default __webpack_public_path__ + "static/media/smile3.fde62a1e.jpg";